module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/core-js/library/modules/$.add-to-unscopables.js
 ** module id = 33
 ** module chunks = 2
 **/